const campoRequerido = "Campo requerido";
const tarjetaInvalida = "Tarjeta inválida";
const fechaInvalida = "Fecha inválida";
const rfcInvalido = "RFC inválido";
const cpInvalido = "Código Postal inválido";
const correoInvalido = "Correo electrónico inválido";
const telInvalido = "Teléfono inválido";
const cadenaVacia = "";

export const mensajesModal = {
  envioExitoso: "Envío exitoso",
  envioFallido: "Fallo en el envio",
  errorCorreo:
    "Ocurrió un error al intentar enviar el correo, intentelo más tarde",
  bodyCorreoExitoso: "Se ha enviado el correo de forma exitosa",
  bodyComprobanteExitoso:
    "Se ha enviado el comprobante de pago de forma exitosa",
  modalEnvioCorreoExito: {
    msjTitle: "Envío exitoso",
    msjBody: "Se ha enviado el correo de forma exitosa",
    withButtons: {
      actionButtons: false,
      msjButton1: "",
    }
  },
  modalErrorCorreoGuiaRef: {
    msjTitle: "Fallo en el envio",
    msjBody: "Ocurrió un error al intentar enviar el correo, intentelo más tarde",
    withButtons: {
      actionButtons: false,
      msjButton1: "",
    }
  },
  modalCobroReferencia: {
    msjTitle: "Pago ya realizado",
    msjBody: "El pago que intenta realizar ya se encuentra realizado, favor de verificar",
    withButton: {
      actionButton: true,
      msjButton1: "Aceptar",
    }
  },
  modalPagoRechazado: {
    msjTitle: "Pago rechazado",
    msjBody:"No ha sido posible realizar el pago debido a que la transacción no fue aprobada por tu institución bancaria.",
    msjBody2:"En caso de que el pago no pueda concretarse, comunícate con tu institución financiera.",
    withButton: {
        actionButton: true,
        msjButton1: "Aceptar",
    }
  },
  modalTarjetaRechazada: {
    msjTitle: "Tarjeta inválida",
    msjBody:"No ha sido posible realizar el pago debido a que los datos bancarios registrados son inválidos.",
    msjBody2:"En caso de que el pago no pueda concretarse, verifica los datos de tu tarjeta o comunícate con tu institución bancaria.",
    withButton: {
        actionButton: true,
        msjButton1: "Aceptar",
    }
  },
  modalContactaEmisor: {
    msjTitle: "Contacte al emisor",
    msjBody:"No ha sido posible realizar el pago, por favor comunícate con tu institución financiera para mayor información.",
    withButton: {
        actionButton: true,
        msjButton1: "Aceptar",
    }
  },
  modalNoDisponible: {
    msjTitle: "Servicio no disponible",
    msjBody:"No ha sido posible realizar el pago debido a que el servicio no se encuentra disponible en estos momentos.",
    msjBody2: "Por favor, inténtelo más tarde.",
    withButton: {
        actionButton: true,
        msjButton1: "Reintentar",
    }
  },
  modalErrorReferencia: {
    msjTitle: "Fallo en la descarga",
    msjBody: "Ocurrió un error al intentar descargar el archivo",
    withButtons: {
        actionButtons: false,
        msjButton1: "",
    }
  }
};

export const downloadPDF = (pdf, nameFile) => {
  const linkSource = `data:application/pdf;base64,${pdf}`;
  const downloadLink = document.createElement("a");
  const fileName = nameFile;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

export const errorCampoRequerido = (error) => {
  if (error) {
    return campoRequerido;
  } else {
    return " ";
  }
};

export const errorMultiple = (name, condicion1, condicion2) => {
  if (condicion1) {
    return campoRequerido;
  } else if (name === "numeroTarjeta" && condicion2) {
    return tarjetaInvalida;
  } else if (name === "fchVencimiento" && condicion2) {
    return fechaInvalida;
  } else if (name === "rfc" && condicion2) {
    return rfcInvalido;
  } else if (name === "codigoPostal" && condicion2) {
    return cpInvalido;
  } else if (name === "correoElectronico" && condicion2) {
    return correoInvalido;
  } else if (name === "telefono" && condicion2) {
    return telInvalido;
  } else {
    return " ";
  }
};

export const formatFchExpire = (value) => {
  var v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
  var matches = v.match(/\d{2,4}/g);
  var match = (matches && matches[0]) || "";
  var parts = [];
  for (let i = 0, len = match.length; i < len; i += 2) {
    parts.push(match.substring(i, i + 2));
  }
  if (parts.length) {
    return parts.join("/");
  } else {
    return value;
  }
};

export const handlePattern = (event, tipoPersona) => {
  switch (event.target.name) {
    case "codigoPostal":
      event.target.pattern = "[0-9]{0,5}";
      break;
    case "telefono":
      event.target.pattern = "[0-9]{0,10}";
      break;
    case "interior":
      event.target.pattern = "[0-9a-zA-Z-]{0,10}";
      break;
    case "numero":
      event.target.pattern = "[0-9a-zA-Z-]{0,10}";
      break;
    case "rfc":
      event.target.pattern =
        tipoPersona === "fisica" ? "[0-9a-zA-Z]{0,13}" : "[0-9a-zA-Z]{0,12}";
      break;
    default:
      break;
  }
};

export const validarDomicilio = (
  responseDomicilio,
  errorDomicilio,
  setErrorDomicilio
) => {
  let invalidCp = false;
  let invalidCorreo = false;
  let invalidTelefono = false;
  if (
    responseDomicilio.codigoPostal !== "" &&
    responseDomicilio.codigoPostal.length < 5
  ) {
    invalidCp = true;
  }
  if (
    responseDomicilio.correoElectronico !== "" &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
      responseDomicilio.correoElectronico
    )
  ) {
    invalidCorreo = true;
  }
  if (
    responseDomicilio.telefono !== "" &&
    responseDomicilio.telefono.length < 10
  ) {
    invalidTelefono = true;
  }
  setErrorDomicilio({
    ...errorDomicilio,
    invalidCP: invalidCp,
    formatCorreo: invalidCorreo,
    invalidTelefono: invalidTelefono,
  });
};

export const validarRfc = (value, errorFiscales, setErrorFiscales) => {
  const validRfc =
    /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A]|[0-9]){1})?$/i.test(
      value
    );
  if (validRfc) {
    setErrorFiscales({
      ...errorFiscales,
      rfcInvalido: false,
      rfc: false,
    });
  } else {
    setErrorFiscales({
      ...errorFiscales,
      rfcInvalido: true,
      rfc: false,
    });
  }
};

export const handleChangeDomicilio = (
  event,
  tipoPersona,
  domicilio,
  setDomicilio
) => {
  handlePattern(event, tipoPersona);
  if (
    event.target.name === "codigoPostal" ||
    event.target.name === "telefono" ||
    event.target.name === "interior" ||
    event.target.name === "numero" ||
    event.target.name === "correoElectronico"
  ) {
    const esValido = event.target.validity.valid;
    if (esValido) {
      setDomicilio({
        ...domicilio,
        [event.target.name]: event.target.value,
      });
    }
  } else {
    setDomicilio({
      ...domicilio,
      [event.target.name]: event.target.value,
    });
  }
};

export const handleChangeAndSetFiscales = (
  event,
  tipoPersona,
  datosFiscales,
  setDatosFiscales
) => {
  if (event.target.name === "rfc") {
    const esValido = event.target.validity.valid;
    if (esValido) {
      setDatosFiscales({
        ...datosFiscales,
        [event.target.name]: event.target.value,
      });
    }
  } else {
    setDatosFiscales({
      ...datosFiscales,
      [event.target.name]: event.target.value,
    });
  }
};

export const blurInputsFiscales = (
  event,
  datosFiscales,
  tipoPersona,
  errorFiscales,
  setErrorFiscales
) => {
  if (datosFiscales[event.target.name] !== "") {
    if (event.target.name === "rfc") {
      if (tipoPersona === "fisica" && event.target.value.length === 13) {
        validarRfc(event.target.value, errorFiscales, setErrorFiscales);
      } else if (tipoPersona === "moral" && event.target.value.length === 12) {
        validarRfc(event.target.value, errorFiscales, setErrorFiscales);
      } else {
        setErrorFiscales({
          ...errorFiscales,
          rfc: false,
          rfcInvalido: true,
        });
      }
    } else {
      setErrorFiscales({
        ...errorFiscales,
        [event.target.name]: false,
      });
    }
  } else {
    setErrorFiscales({
      ...errorFiscales,
      [event.target.name]: true,
    });
  }
};

const blurInputCorreo = (name, domicilio, errorDomicilio, setErrorDomicilio) =>{
    const validCorreo = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(domicilio.correoElectronico);
    if (!validCorreo) {
        setErrorDomicilio({
          ...errorDomicilio,
          [name]: false,
          formatCorreo: true,
        });
      } else{
        setErrorDomicilio({
          ...errorDomicilio,
          [name]: false,
          formatCorreo: false,
        });
      }
}

export const blurInputsDomicilio = (
  event,
  domicilio,
  errorDomicilio,
  setErrorDomicilio
) => {
  if (domicilio[event.target.name] !== "") {
    if ( event.target.name === "correoElectronico" ){
        blurInputCorreo(event.target.name, domicilio, errorDomicilio, setErrorDomicilio);
    } else if (
      event.target.name === "codigoPostal" &&
      event.target.value.length < 5
    ) {
      setErrorDomicilio({
        ...errorDomicilio,
        [event.target.name]: false,
        invalidCP: true,
      });
    } else if (
      event.target.name === "codigoPostal" &&
      event.target.value.length === 5
    ) {
      setErrorDomicilio({
        ...errorDomicilio,
        [event.target.name]: false,
        invalidCP: false,
      });
    } else if (
      event.target.name === "telefono" &&
      event.target.value.length < 10
    ) {
      setErrorDomicilio({
        ...errorDomicilio,
        [event.target.name]: false,
        invalidTelefono: true,
      });
    } else if (
      event.target.name === "telefono" &&
      event.target.value.length === 10
    ) {
      setErrorDomicilio({
        ...errorDomicilio,
        [event.target.name]: false,
        invalidTelefono: false,
      });
    } else {
      setErrorDomicilio({
        ...errorDomicilio,
        [event.target.name]: false,
      });
    }
  } else {
    setErrorDomicilio({
      ...errorDomicilio,
      [event.target.name]: true,
    });
  }
};

export const getClassNamePersona = (tipoPersona) => {
  if (tipoPersona !== "fisica") {
    return "gridTipoPersona marginGridFisica";
  }
  return "gridTipoPersonaSelected marginGridFisica";
};

export const getClassNamePersonaMoral = (tipoPersona) => {
  if (tipoPersona !== "moral") {
    return "gridTipoPersona";
  }
  return "gridTipoPersonaSelected";
};

export const showErrorInput = (value1, value2) => {
  return value1 || value2;
};

export const handleCloseModalTimbrados = (data, action, dispatch, setModalTimbrado, 
    setErrorTimbrado, setRfcInvalido) => {
  dispatch(action.onLoading(true));
  const jsonTimbrado = {
    idPago: data.datosFiscales.idPago,
    estatusCfdi: data.datosFiscales.estatusCfdi,
    rfc: data.datosFiscales.rfc,
    nombreRazon: data.datosFiscales.nombreRazon,
    apellidoPaterno: data.datosFiscales.apellidoPaterno,
    apellidoMaterno: data.datosFiscales.apellidoMaterno,
    numeroCliente: data.global.clienteUnico,
    calle: data.domicilio.calle,
    numero: data.domicilio.numero,
    interior: data.domicilio.interior,
    colonia: data.domicilio.colonia,
    codigoPostal: data.domicilio.codigoPostal,
    delegacionMunicipio: data.domicilio.delegacionMunicipio,
    ciudad: data.domicilio.ciudad,
    estado: data.domicilio.estado,
    pais: "",
    telefono: data.domicilio.telefono,
    correoElectronico:
    data.domicilio.correoElectronico !== ""
        ? data.domicilio.correoElectronico
        : localStorage.getItem("correoSoyCliente"),
  };
  dispatch(action.getRfcValido(data.datosFiscales.rfc, data.global.tid))
    .then((responseRfcValido) => {
      if (responseRfcValido.data[0].exists) {
        dispatch(action.postTimbradoCfdi({ ...jsonTimbrado }, data.global.tid))
          .then((response) => {
            dispatch(action.onLoading(false));
            setModalTimbrado({
              openModalTimbrado: true,
            });
          })
          .catch((erro) => {
            console.error(erro);
            dispatch(action.onLoading(false));
            setErrorTimbrado(true);
          });
      } else {
        dispatch(action.onLoading(false));
        setRfcInvalido(true);
      }
    })
    .catch((error) => {
      console.error(error);
      dispatch(action.onLoading(false));
      setErrorTimbrado(true);
    });
};

export const validCadenaVacia = (value)=>{
    if(value && value !== cadenaVacia){
        return value;
    }
    return cadenaVacia;
}

export const isValidForm = (tipoPersona, datosFiscales, domicilio, errorDomicilio, errorFiscales, cambiosError)=>{
    return (tipoPersona === "fisica"
              ? datosFiscales.apellidoPaterno === "" ||
                datosFiscales.apellidoMaterno === "" ||
                datosFiscales.nombreRazon === ""
              : datosFiscales.nombreRazon === "") ||
            datosFiscales.rfc === "" ||
            domicilio.calle === "" ||
            domicilio.numero === "" ||
            domicilio.codigoPostal === "" ||
            domicilio.colonia === "" ||
            domicilio.delegacionMunicipio === "" ||
            domicilio.estado === "" ||
            domicilio.correoElectronico === "" ||
            errorDomicilio.formatCorreo ||
            errorFiscales.rfc ||
            errorFiscales.rfcInvalido ||
            errorDomicilio.codigoPostal ||
            errorDomicilio.invalidCP ||
            errorDomicilio.telefono ||
            errorDomicilio.invalidTelefono ||
            domicilio.telefono === "" ||
            !cambiosError;
}; 


// WEBPACK FOOTER //
// ./src/pago-deducible-auto/utils.js